export default "__VITE_ASSET__KAFP3J51__"